<template>
  <div>
    <div v-if="!isChartFilterError" class="rate-total-chart">
      <VsLoader :visible="!!rateTotalData.isLoading" />
      <template v-if="chartData">
        <Chart
          :chartData="chartData"
          :options="chartOptions"
          :styles="{
            width: '99%',
          }"
        />
      </template>
    </div>
    <VsNoChartData v-else height="450px" :withButton="showResetFiltersButton">
      <template v-slot:errorMessage>
        <p>{{ "charts.errorMessage.productFilterError" | t }}</p>
      </template>
    </VsNoChartData>
  </div>
</template>

<script>
import Chart from "./chart";
import tooltipConfig from "@/misc/chartTooltip";
const MAIN_COLOR = "#16C6B9";
let _this = null;

export default {
  components: {
    Chart,
  },
  props: {
    rateTotalData: {
      type: Object,
      default: () => null,
    },
    rateTotalAttr: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      chartData: null,
    };
  },
  computed: {
    isChartFilterError() {
      const { rateData, valueData } = this.rateTotalData;
      return rateData?.isError || valueData?.isError;
    },
    showResetFiltersButton() {
      return this.isChartFilterError && this.rateTotalData.showResetFiltersButton;
    },
    isChartAvailable() {
      if (!this.rateTotalData || !this.rateTotalData.rateData || !this.rateTotalData.valueData) {
        return false;
      }
      return true;
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        elements: { point: { radius: 0.05 } },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              position: "left",
              id: "bar-axis",
              gridLines: {
                drawBorder: false,
              },
              ticks: {
                // Include a dollar sign in the ticks
                callback: function (value, _index, _values) {
                  return _this.$options.filters.numberFormat(value);
                },
              },
            },
            {
              stacked: true,
              position: "right",
              id: "line-axis",
              gridLines: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                // Include a dollar sign in the ticks
                callback: function (value, _index, _values) {
                  return _this.$options.filters.numberFormat(value, "0.0%");
                },
              },
            },
          ],
        },
        tooltips: {
          ...tooltipConfig,
          intersect: false,
          callbacks: {
            label: function (tooltipItem, _data) {
              const chartInfo = _this.rateTotalData.chartInfo || _this.rateTotalAttr;
              if (tooltipItem.datasetIndex === 0) {
                return `${_this.$t(chartInfo.valueTitle)}: ${_this.$options.filters.numberFormat(
                  tooltipItem.yLabel,
                  "0,0"
                )}`;
              }
              if (tooltipItem.datasetIndex === 1) {
                return `${_this.$t(chartInfo.rateTitle)}: ${_this.$options.filters.numberFormat(
                  tooltipItem.yLabel,
                  "0.00%"
                )}`;
              }
            },
            labelTextColor: function (_tooltipItem, _chart) {
              return "#16C6B9";
            },
          },
        },
      };
    },
  },
  watch: {
    rateTotalData() {
      this.setChartData();
    },
    isChartAvailable() {
      this.setChartData();
    },
  },
  created() {
    _this = this;
    this.setChartData();
  },
  methods: {
    async setChartData() {
      if (this.isChartAvailable && !this.isChartFilterError) {
        this.chartData = await this.rateTotalDataCollection();
      }
    },
    rateTotalDataCollection() {
      let returnObject = {
        labels: [],
        datasets: [
          {
            type: "bar",
            data: [],
            backgroundColor: "rgba(22, 198, 185, 0.2)", // todo: set valiable
            hoverBackgroundColor: "rgba(22, 198, 185, 0.65)",
            borderColor: MAIN_COLOR,
          },
          {
            type: "line",
            data: [],
            backgroundColor: "rgba(0, 0, 0, 0)", // todo: set valiable
            hoverBackgroundColor: MAIN_COLOR,
            borderColor: MAIN_COLOR,
            pointHoverBackgroundColor: MAIN_COLOR,
            yAxisID: "line-axis",
            borderWidth: 2,
            pointHoverRadius: 3,
          },
        ],
      };
      this.rateTotalData.valueData.forEach((data, index) => {
        returnObject.labels.push(
          data.date && data.date.length === 8 ? `${data.date.substr(4, 2)}/${data.date.substr(6, 2)}` : ""
        );
        returnObject.datasets[0].data.push(data.val);
        returnObject.datasets[1].data.push(this.rateTotalData.rateData[index].val);
      });
      return Promise.resolve(returnObject);
    },
  },
};
</script>

<style scoped lang="scss">
.rate-total-chart {
  position: relative;
  max-height: 467px;
  margin-bottom: 20px;
  padding: 20px;
  border: solid 1px $gray-300;
  background-color: white;
}
</style>
